import React, { useEffect, useMemo, useState } from 'react';
import { Polygon, Marker, InfoWindow } from '@react-google-maps/api';
import GridContainer from 'components/Grid/GridContainer';
import { makeStyles } from '@material-ui/core/styles';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from 'components/CustomButtons/Button';
import CloseIcon from '@material-ui/icons/Close';
import GridItem from 'components/Grid/GridItem';
import { IconButton } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';

import { WithApp } from 'contexts/appContext';

import LayerLegend from 'components/Tvendo/Common/LayerLegend';
import LayerCombo from 'components/Tvendo/Common/LayerCombo';
import { wsGet } from 'services/WService';
import wkt from 'wkt';
import GoogleMapCustom from 'components/Tvendo/Common/GoogleMapCustom';

const useStyles = makeStyles(() => ({
  closeButton: {
    float: 'right',
  },
  h5: {
    color: 'black',
    fontWeight: '500',
    marginLeft: '20px',
  },
  divStyle: {
    padding: '4px',
    listStyle: 'none',
    background: '#c8f7ec',
    borderRadius: '5px',
    '& span': {
      fontSize: '15px',
      fontWeight: 500,
    },
  },
}));

export default WithApp(function Modal(props) {
  const classes = useStyles();
  const handleClose = () => {
    setZone({});
    setInfoData({});
    setOpen(false);
    setZone({});
    setPolygons([]);
    setRoutes([]);
    setAddresses([]);
    setHoverDescription(null);
    setOpenInfo(false);
  };

  //code maps
  const [mapCenter, setMapCenter] = useState({
    lat: -14.07543457346045,
    lng: -75.73423487506565,
  });

  const [openInfo, setOpenInfo] = useState(false);
  const [infoData, setInfoData] = useState({});

  const { open, setOpen, zoneId, layers } = props;
  const [selectedLayerId, setSelectedLayerId] = useState();

  const [zone, setZone] = useState({});

  const [routes, setRoutes] = useState([]);
  const [polygons, setPolygons] = useState([]);

  const [hoverDescription, setHoverDescription] = useState(null);
  const [addresses, setAddresses] = useState([]); //LISTA DE direcciones para sacar los marcadores

  async function getZone() {
    let response = await wsGet('base/zone', zoneId);
    if (response.success) {
      setZone(response.data);

      if (response.data.latitude !== null && response.data.longitude !== null) {
        setMapCenter({
          lat: response.data.latitude,
          lng: response.data.longitude,
        });
      }

      setPolygons(
        response.data.routes
          .filter((item) => !!item.geometry)
          .map((item) => {
            let wktParsed = wkt.parse(item.geometry);
            return {
              route: item,
              coordinates: wktParsed.coordinates[0].map((point) => {
                return {
                  lng: point[0],
                  lat: point[1],
                };
              }),
            };
          }),
      );

      setRoutes(response.data.routes);
      setAddresses(response.data.addresses);
    }
  }

  useEffect(() => {
    if (open) {
      getZone();
    }
  }, [open]);

  const filteredPolygons = useMemo(() => {
    if (selectedLayerId === undefined) return polygons;
    return polygons.filter((polygon) => polygon.route.base_layer_id == selectedLayerId);
  }, [polygons, selectedLayerId]);

  const filteredAddresses = useMemo(() => {
    if (selectedLayerId === undefined) return addresses;
    let routes = filteredPolygons.map((polygon) => polygon.route.id.toString());
    return addresses.filter((address) => routes.includes(address.base_route_id));
  }, [addresses, filteredPolygons, selectedLayerId]);

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xl">
      <DialogTitle>
        {zone.description}
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={() => {
            handleClose();
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <GridContainer>
          <GridItem xs={12} sm={12} md={8} lg={9} xl={10}>
            <div style={{ display: 'flex' }}>
              <h5 style={{ color: 'black', fontWeight: '500' }}>
                Nombre: {infoData.CardName || '-'}
              </h5>
              <h5 className={classes.h5}>Dirección: {infoData.Street || '-'}</h5>
            </div>
          </GridItem>
          <GridItem xs={12} sm={12} md={4} lg={3} xl={2}>
            <LayerCombo
              layers={layers}
              isFilter
              label={'Filtro de capas'}
              onChange={(_, layer) => setSelectedLayerId(layer.id)}
            />
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12}>
            <div>
              <GridContainer>
                <GridItem xs={12} md={6} lg={8} xl={9}>
                  <div style={{ display: 'flex' }}>
                    <h5 style={{ color: 'black', fontWeight: '500' }}>
                      Ruta:{' '}
                      {hoverDescription == null ? (
                        <span style={{ fontWeight: 100 }}>"Pase el mouse por un polígono"</span>
                      ) : (
                        <span style={{ color: '#93a294' }}>{hoverDescription}</span>
                      )}
                    </h5>
                    <h5 className={classes.h5}>Clientes: {zone.addressesCount}</h5>
                    {/* <h5 className={classes.h5}>
                  Clientes por ruta : "proceso..."
                </h5> */}
                    <h5 className={classes.h5}>Clientes Marcados: {addresses.length}</h5>
                  </div>
                </GridItem>
                <GridItem xs={12} md={6} lg={4} xl={3}>
                  <LayerLegend layers={layers} />
                </GridItem>
              </GridContainer>
              <GoogleMapCustom
                mapContainerStyle={{
                  width: '100%',
                  height: '100%',
                  minHeight: '600px',
                }}
                zoom={13}
                center={mapCenter}
                options={{
                  disableDoubleClickZoom: true,
                }}
                onClick={() => {
                  setOpenInfo(false);
                }}
              >
                {!!zone.geometry ? (
                  <Polygon
                    paths={wkt.parse(zone.geometry).coordinates[0].map((point) => {
                      return {
                        lng: point[0],
                        lat: point[1],
                      };
                    })}
                    options={{
                      fillColor: '#ffd431bd',
                    }}
                  />
                ) : undefined}
                {filteredPolygons.map((polygon, i) => {
                  return (
                    <Polygon
                      key={i}
                      paths={polygon.coordinates}
                      onMouseOver={() => {
                        setHoverDescription(polygon.route.description);
                      }}
                      onMouseOut={() => {
                        setHoverDescription('"Pase el mouse por un polígono"');
                      }}
                      options={{
                        fillColor: layers.find((layer) => layer.id == polygon.route.base_layer_id)
                          .color,
                      }}
                    />
                  );
                })}
                {filteredAddresses.map((address, i) => {
                  return (
                    <Marker
                      key={i}
                      position={{
                        lat: parseFloat(address.latitude),
                        lng: parseFloat(address.longitude),
                      }}
                      onClick={() => {
                        setOpenInfo(true);
                        setInfoData(address);
                      }}
                    />
                  );
                })}
                {openInfo ? (
                  <InfoWindow
                    position={{
                      lat: parseFloat(infoData.latitude),
                      lng: parseFloat(infoData.longitude),
                    }}
                    onCloseClick={() => {
                      setOpenInfo(false);
                      setInfoData({});
                    }}
                    options={{
                      pixelOffset: {
                        width: 0,
                        height: -25,
                      },
                    }}
                  >
                    <div className={classes.divStyle}>
                      <li>
                        <span>Nombre: </span>
                        {infoData.CardName}
                      </li>
                      <li>
                        <span>Dir: </span>
                        {infoData.Address2}
                      </li>
                    </div>
                  </InfoWindow>
                ) : undefined}
              </GoogleMapCustom>
            </div>
          </GridItem>
        </GridContainer>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            handleClose();
          }}
          color={props.themeContext.buttonColorDanger}
          size="sm"
        >
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
});
